import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PATH } from '../../../constants';
import { scrollElementIntoView } from '../../../utils';
import { Link } from 'react-scroll';

import { ReactComponent as IconSearch } from '../../../img/search.svg';
import { ReactComponent as IconAngleDown } from '../../../img/angle-down.svg';

const BoxWithUmbracoSearch = ({ anchor, searchPhrase }) => {
    const { t } = useTranslation();
    const location = window.location.origin;
    const { pathname } = useLocation();
    const siteLanguage = pathname.slice(0, 3);
    const searchURL = PATH.eqSearch;
    const hostURL = location + siteLanguage + searchURL;
    const params = 'q=' + searchPhrase + '&search=GO';
    const searchParams = new URLSearchParams(params);

    return (
        <section className="highlited-box" data-cy="umbraco-search-box">
            <h3 className="highlited-box__heading">
                {t('ui.boxWithUmbracoSearch.header')}
            </h3>
            <p>{t('ui.boxWithUmbracoSearch.text')}</p>
            <div className="highlited-box__cta">
                <a
                    href={`${hostURL}?${searchParams}`}
                    className="button button--with-left-icon btn-secondary"
                >
                    <IconSearch className="icon icon--s" aria-hidden="true" focusable="false" />
                    {t('ui.boxWithUmbracoSearch.button')}
                </a>
                <Link
                    onClick={(e) => scrollElementIntoView(e, anchor)}
                    className="link link--more highlited-box__link"
                    to={anchor}
                    title={t('ui.boxWithUmbracoSearch.link.title')}
                    href={`#${anchor}`}
                    data-cy="umbraco-search-again"
                >
                    {t('ui.boxWithUmbracoSearch.link.text')}
                    <IconAngleDown className="icon icon--xs icon--revert" aria-hidden="true" focusable="false" />
                </Link>
            </div>
        </section>
    );
};

export default BoxWithUmbracoSearch;
